var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.96 46.3543C18.8986 46.3543 35.6691 28.2473 35.6691 18.3639C35.6691 8.48052 27.7404 0.468456 17.96 0.468456C8.17957 0.468456 0.250977 8.48052 0.250977 18.3639C0.250977 28.2473 17.0215 46.3543 17.96 46.3543ZM17.96 27.3146C22.9187 27.3146 26.9386 23.2524 26.9386 18.2415C26.9386 13.2306 22.9187 9.16853 17.96 9.16853C13.0014 9.16853 8.98156 13.2306 8.98156 18.2415C8.98156 23.2524 13.0014 27.3146 17.96 27.3146Z",
    fill: "#7D0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.250977 18.3639C0.250977 28.2473 17.0215 46.3543 17.96 46.3543V27.3146C13.0013 27.3144 8.98156 23.2524 8.98156 18.2415C8.98156 13.2307 13.0013 9.16855 17.96 9.16853V0.468456C8.17957 0.468456 0.250977 8.48052 0.250977 18.3639Z",
    fill: "#440606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.9676ca5312ce192435d50798cf992fb0.svg";
export { ForwardRef as ReactComponent };